export default function WhatIsThis() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            這是什麼服務？
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>
        
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-10 md:p-14 shadow-sm border border-gray-100">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6">
            我們提供<strong className="text-teal-600">「0元一頁式網站」</strong>，<br />
            讓您可以在最短時間內，擁有一個可對外使用的品牌入口。
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
            這一頁還不是最終完整版，<br />
            而是讓你<strong className="text-gray-900">先開始營業、先接觸客戶、先驗證方向</strong>。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center p-6">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-rocket-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">快速上線</h3>
            <p className="text-sm text-gray-600">最短時間擁有品牌入口</p>
          </div>
          <div className="text-center p-6">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-heart-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">驗證方向</h3>
            <p className="text-sm text-gray-600">先接觸客戶再決定擴大</p>
          </div>
          <div className="text-center p-6">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">0元建置</h3>
            <p className="text-sm text-gray-600">不用一次投入高額費用</p>
          </div>
        </div>
      </div>
    </section>
  );
}
